
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Opz2Empty',
    props: {
        icon: { type: String, default: '🗓' },
        title: { type: String, required: true },
        hint: { type: String, default: '' },
    },
})
